






























































import '@/router/hook';
import { Component, Prop } from 'vue-property-decorator';
import Head from '@/components/Head.vue'; // @ is an alias to /src
import Nav from '@/components/Nav.vue';
import Grid from '@/components/Grid.vue';
import Carousel from '@/components/Carousel.vue';
import { Swiper, SwiperOptions } from 'swiper/bundle';
import { tracking } from '@/lib/tracking';
import WeixinMixin from '../shared/weixin-mixin';

@Component({
  components: {
    'training-head': Head,
    'training-carousel': Carousel,
    'training-grid': Grid,
    'training-nav': Nav,
  },
})
export default class Home extends WeixinMixin {
  @Prop(String) readonly index: string | undefined;

  currentNav = 0

  getQueryVariable(variable: string) {
       if (variable in this.$route.query) {
         return this.$route.query[variable]
       }
       return false;
  }

  created() {
    const r = Math.random() * 1000000;
    if (this.index) {
      sessionStorage.setItem( "homeSwiperIndex", this.index );
      this.$router.push(`/?index=${this.index}&${r}`);
    } else {
      this.$router.push(`/?${r}`);
    }
    tracking({isAction: false, pageName : `Training_Home_${this.index || 0}`})
  }

  mounted() {
    const swiperParams: SwiperOptions = {
      slidesPerView : 1,
      spaceBetween : 10,
      on: {
        slideChange: (s) => {
          window.console.log('init')
          const currentIndex = this.currentNav;
          const idx = s.activeIndex;
          if (currentIndex !== idx) {
            this.currentNav = idx;
            sessionStorage.setItem("homeSwiperIndex", `${idx}`);
            this.$router.replace(`/?index=${idx}`);
          }
        },
      },
    };

    const swiper = new Swiper('.home-swiper-container', swiperParams);
    const index: number = parseInt(sessionStorage.getItem("homeSwiperIndex") || '0')
    swiper.slideTo(index);
  }

  swiperChange(idx: number) {
    const ele = document.querySelector('.home-swiper-container') as any;
    const swiper = ele?.swiper as Swiper;
    swiper.slideTo(idx);
  }

  beforeDestroy() {
    const home = document.querySelector(".home-swiper-container") as any;
    const homeSwiper = home?.swiper as Swiper;
    homeSwiper?.destroy();
  }
}
